import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { QuizComponent } from '../../../courses/components/quiz/quiz.component';
import { ParentQuizResult } from '../../models/parent-learning.types';

@Component({
  selector: 'app-parent-learn-quiz',
  standalone: true,
  imports: [CommonModule, TranslatePipe, QuizComponent],
  templateUrl: './parent-learn-quiz.component.html',
  styleUrl: './parent-learn-quiz.component.scss',
})
export class ParentLearnQuizComponent {
  quizId = input('');
  taskId = input<string | null>(null);
  description = input('');
  /** When true, quiz is for review only (completed lesson) */
  reviewMode = input(false);

  completed = output<ParentQuizResult>();
  answerIncorrect = output<void>();
}
